import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { generalService } from '../services/general.service';
import { DataSourceGrid, datosGrid } from '../utils/llenarGrid.component';
import { utils } from '../utils/utils';
import { FormControl } from '@angular/forms';
import { Cliente } from '../models/cliente';

@Component({
  selector: 'my-asistencia-nomina',
  templateUrl: './controlAsistenciaNomina.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class controlAsistenciaNominaComponent {
  public gridDatos:any;
  public datosModelos:Array<any>;
  assistenceTypeFiltradas: any;
  dataSource: DataSourceGrid | null; 
  public assistenceType:Array<any>;
  isExtendedRow = (index, item) => item.ordenar;
  public _utils:utils;
  //public guardarBool = false;
  public fechaHoy = "";
  public fechaAyer = "";
  public diaSigBool = true;
  public diaDescanso = [
    {DAY_OF_REST: 'Lu', day: 'Lunes'},
    {DAY_OF_REST: 'Ma', day: 'Martes'},
    {DAY_OF_REST: 'Mi', day: 'Miércoles'},
    {DAY_OF_REST: 'Ju', day: 'Jueves'},
    {DAY_OF_REST: 'Vi', day: 'Viernes'},
    {DAY_OF_REST: 'Sa', day: 'Sábado'},
    {DAY_OF_REST: 'Do', day: 'Domingo'},
  ];
  clienteCtrl: FormControl;
  clientesFiltrados: any;
  public clientes:Array<any>;
  public clientesArray:Array<number>;
  public bloqueoAsis = false;
  public fechaBloqueo = "";
  diaHoy ="";
  diaAyer = "";
  days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

  constructor(private _generalService: generalService) {
  	this.datosModelos = new Array();
  	this._utils = new utils();
    this.clienteCtrl = new FormControl();
    this.clientesArray = new Array<number>();
  }

  ngOnInit() {
    this.fechaFinNomina();
    this.getClientes();
  	this.getAssistenceType(); 	
  }

  consultarAsistenciaNomina(){
    let params = null;
    let administrativo = false;
    let noAsignados = false;
    if(this.clientesArray.length > 0){
      let arregloCliente = this.clientesArray.slice();
      var index = arregloCliente.indexOf(-1);
      if(index > -1)
      {
        arregloCliente.splice(index, 1);
        noAsignados = true;
      }
      index = arregloCliente.indexOf(-2);
      if(index > -1)
      {
        arregloCliente.splice(index, 1);
        administrativo = true;
      }
      params = JSON.stringify(arregloCliente);
    }
    else{
      administrativo = true;
      noAsignados = true;
    }

    let paramsJSON: any = {};
    paramsJSON.fechaHoy = this.fechaHoy;
    paramsJSON.param2 = params;
    paramsJSON.param3 = noAsignados;
    paramsJSON.param4 = administrativo;
    paramsJSON.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(paramsJSON,"asistencianomina/consultarAsistenciaNomina/").subscribe(
        result => {
           	this.datosModelos = JSON.parse(result);
          	this.gridDatos = new datosGrid(this.datosModelos);
          	this.dataSource = new DataSourceGrid(this.gridDatos);
          },
        error => {
          console.log(<any>error);
        }
      );
  }

  fechaConsulta(numero){
  	let fechaC = new Date();
  	if(numero == 0){ 		
	    this.fechaHoy = this._utils.convertDate(fechaC, "yyyy-mm-dd");
      this.diaHoy = this.days[fechaC.getDay()];
	    fechaC.setDate(fechaC.getDate() - 1);
      this.diaAyer = this.days[fechaC.getDay()];
	    this.fechaAyer = this._utils.convertDate(fechaC, "yyyy-mm-dd");
  	}
  	else{
  		let fechaArray:any = this.fechaHoy.split("-");
  		let fecha = new Date(fechaArray[0], (parseInt(fechaArray[1]) - 1), fechaArray[2]);
  		fecha.setDate(fecha.getDate() - numero);
      
      this.diaHoy = this.days[fecha.getDay()];
  		this.fechaHoy = this._utils.convertDate(fecha, "yyyy-mm-dd");
  		fechaArray = this.fechaAyer.split("-");
  		fecha = new Date(fechaArray[0], (parseInt(fechaArray[1]) - 1), fechaArray[2]);
  		fecha.setDate(fecha.getDate() - numero);
      this.diaAyer = this.days[fecha.getDay()];
	    this.fechaAyer = this._utils.convertDate(fecha, "yyyy-mm-dd");
	    if(this._utils.convertDate(fechaC, "yyyy-mm-dd") == this.fechaHoy)
	  	{
	  		this.diaSigBool = true;
	  	}
	  	else{
	  		this.diaSigBool = false;
	  	}

      if(this.fechaBloqueo != ""){
        if(this.fechaHoy <= this.fechaBloqueo)
        {
          this.bloqueoAsis = true;
        }
        else{
          this.bloqueoAsis = false;
        }
      }
  	}
  	this.consultarAsistenciaNomina();
  }

  getClientes(){
      let cliente = new Cliente();
      cliente.loacs = sessionStorage.getItem('acslo');
      this._generalService.metodoCallParams(cliente,"misc/consultarClientes/").subscribe(
        result => {
          this.clientes = JSON.parse(result);
          this.clientesFiltrados = this.clienteFilter('');                            
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  fechaFinNomina(){
      this._generalService.metodoCall("misc/fechaFinNomina/").subscribe(
        result => {
          if(result != "primerNomina")
            this.fechaBloqueo = result;                          
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  onKeyUp(event: any): void {
    this.assistenceTypeFiltradas = this.assistenceTypeFilter(event.target.value);
  }

  onKeyUpHoy(event: any): void {
    this.assistenceTypeFiltradas = this.assistenceTypeFilter(event.target.value);
  }

  onKeyUpCliente(event: any): void {
    this.clientesFiltrados = this.clienteFilter(event.target.value);
  }

  clienteFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.clientes.filter(s => new RegExp(`^${val}`, 'gi').test(s.CUSTOMER_NAME));
    } else {
      arr = this.clientes;
    }
    return Observable.of(arr);
  }

  displayFnCliente(id) {
    if (!id) return '';
    let index = this.clientes.findIndex(emp => emp.CUSTOMER_ID === id);
    return this.clientes[index].CUSTOMER_NAME;
  }

  getAssistenceType(){
      this._generalService.metodoCall("misc/consultarLookup/ASSISTANCE_STATUS").subscribe(
        result => {
          this.assistenceType = JSON.parse(result);
          this.assistenceTypeFiltradas = this.assistenceTypeFilter('');     
          this.fechaConsulta(0);                       
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  descansoU(empleado){
    this._generalService.metodoCall("asistencianomina/actualizar_hr_person_day/"+empleado.ID+"/"+empleado.DAY_OF_REST).subscribe(
        result => {
            this._generalService.toastCall("El registro se modificó exitosamente!");          
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  assistenceTypeFilter(val: string): Observable<any> {
    let arr: any[];
    if (val) {
      arr = this.assistenceType.filter(s => new RegExp(`^${val}`, 'gi').test(s.MEANING));
    } else {
      arr = this.assistenceType;
    }
    return Observable.of(arr);
  }

  // displayFn(empleado:any, dia:string, idTipo:any) {
  //   if (!idTipo) return '';
  //   let index = this.assistenceType.findIndex(aType => aType.LOOKUP_ID === idTipo);
  //   if(this.guardarBool && dia != '')
  //   	this.guardar(idTipo, empleado, dia);
  //   return this.assistenceType[index].NAME;
  // }

  // cambiarBool(){
  // 	this.guardarBool = true;
  // }

  // guardar(idTipo, empleado, dia){
  // 		this.guardarBool = false;
  // 		empleado.LOOKUP_ID = idTipo;
  // 		empleado.DATE = (dia == "today") ? this.fechaHoy : this.fechaAyer;
  // 		let metodo = "asistencianomina/empleadoAsistencia/";

  // 		this._generalService.metodoCallParams(empleado, metodo).subscribe(
  //         result => {
  //           if(result == "")
  //           {
  //             this._generalService.toastCall("El registro se modificó exitosamente!");
  //           }
  //           else{
  //              console.log("no exitoso");
  //           }
  //         },
  //         error => {
  //           var errorMsj = <any>error;
  //           console.log(errorMsj);
  //         }
  //     ); 
  // }

  cambiarDia(tipo, evento){
      if(evento.keyCode == 9){
        if(tipo == 1)
        {
            this.fechaConsulta(1);
        }
        else{
            this.fechaConsulta(-1);
        }
      }
  }

  guardarDia(empleado, dia){
      //this.guardarBool = false;
      empleado.ASSISTANCE_STATUS = (dia == "today") ? empleado.today : empleado.lastday;
      empleado.DATE = (dia == "today") ? this.fechaHoy : this.fechaAyer;
      empleado.loacs = sessionStorage.getItem("acslo");
      let metodo = "asistencianomina/empleadoAsistencia/";

      this._generalService.metodoCallParams(empleado, metodo).subscribe(
          result => {
            if(result == "")
            {
              this._generalService.toastCall("El registro se modificó exitosamente!");
            }
            else{
               console.log("no exitoso");
            }
          },
          error => {
            var errorMsj = <any>error;
            console.log(errorMsj);
          }
      ); 
  }

}


// WEBPACK FOOTER //
// ./src/app/asistenciaNomina/controlAsistenciaNomina.component.ts